// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__uvGM3","rotation":"SmallLoader_rotation__YrQvI"};